import { render, staticRenderFns } from "./TourGuides.vue?vue&type=template&id=1ffd5292"
import script from "./TourGuides.vue?vue&type=script&lang=js"
export * from "./TourGuides.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports